import httpService from '@/services/httpService'
import _ from 'lodash'

export const types = {
  ADD_HTML_DATA: 'agency-mode-data/ADD_HTML_DATA',
  RESET_DATA: 'agency-mode-data/RESET_DATA'
}
const emptyData = {
  html: ''
}
const state = { ...emptyData }

const mutations = {
  [types.ADD_HTML_DATA]: function (state, html) {
    state.html = html
  },
  [types.RESET_DATA]: function (state, data) {
    state = { ...data }
  }
}

const actions = {
  getHTML: async function ({ commit }, { requestUrl, params }) {
    const { data, url } = await httpService.get(requestUrl, { params, returnWithUrl: true })
    if (!data) {
      return requestUrl
    }
    commit(types.ADD_HTML_DATA, data)
    return url
  },
  setHTML: async function ({ commit }, html) {
    commit(types.ADD_HTML_DATA, html)
    return html
  },
  submitRequests: async function ({ commit }, { requestUrl, method, params }) {
    const request = httpService[method.toLowerCase()]
    const { data, url } = await request(
      requestUrl,
      method === 'get' ? { params, returnWithUrl: true } : params,
      { returnWithUrl: true }
    )
    if (!data) {
      return requestUrl
    }
    commit(types.ADD_HTML_DATA, data)
    return url
  },
  resetData: function ({ commit }) {
    commit(types.RESET_DATA, emptyData)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
